import React, { useEffect } from 'react';
import Modal from 'common/components/modal';
import { useTranslation } from 'react-i18next';
import { Trash as TrashIcon } from 'common/components/svgs';
import { Divider } from 'antd';

const BulkDeleteModal = ({
  visible,
  setVisible = () => {},
  count = 0,
  onDelete = () => {},
  deleteLoading,
}) => {
  const { t } = useTranslation();
  const [modalVisible, setModalVisible] = React.useState(visible);

  const handleCancel = () => {
    setModalVisible(false);
    setVisible(false);
  };

  useEffect(() => {
    setModalVisible(visible);
  }, [visible]);

  return (
    <Modal
      width={556}
      visible={modalVisible}
      cancelButtonProps={{ style: { marginRight: 8 }, 'data-testid': 'bulk-delete-modal-cancel' }}
      onCancel={handleCancel}
      okText={t('cms:cms.property.listing_management.bulk_delete.confirm')}
      okButtonProps={{
        type: 'danger',
        style: { margin: 0 },
        loading: deleteLoading,
        'data-testid': 'bulk-delete-modal-ok',
      }}
      onOk={onDelete}
    >
      <div className="bulk-delete-modal__content" data-testid="bulk-delete-modal-content">
        <div className="bulk-delete-modal__title">
          {t('cms:cms.property.listing_management.bulk_delete.modal.title')}
        </div>
        <div className="bulk-delete-modal__description">
          <div className="bulk-delete-modal__desc-left">
            <TrashIcon className="bulk-delete-modal__delete-icon" />
            <div className="bulk-delete-modal__desc-text">
              {t('cms:cms.property.listing_management.bulk_delete.button')}
            </div>
          </div>
          <Divider type="vertical" className="bulk-delete-modal__divider" />
          <div className="bulk-delete-modal__desc-right">
            {`${count} ${t('cms:cms.property.listing_management.bulk_delete.modal.desc')}`}
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default BulkDeleteModal;
